"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Message_1 = __importDefault(require("../message/Message"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
const VerifyingIcon_1 = __importDefault(require("../posa/VerifyingIcon"));
const RedirectWalletOverlayStyled_1 = __importDefault(require("./RedirectWalletOverlayStyled"));
const RedirectWalletOverlay = ({ image }) => {
    return (react_1.default.createElement(RedirectWalletOverlayStyled_1.default, { className: "overlay" },
        react_1.default.createElement("div", { className: "overlay-wrapper" },
            react_1.default.createElement("div", { className: "overlay-content" },
                react_1.default.createElement("div", { className: "overlay-content-wrapper" },
                    react_1.default.createElement("div", { className: "overlay-content-block" },
                        react_1.default.createElement("h1", null,
                            react_1.default.createElement(Message_1.default, { code: "epic.code.redemption.posa.page.vbuckscard.validate.isWalletCode.message" })),
                        react_1.default.createElement("p", null,
                            react_1.default.createElement("span", null,
                                react_1.default.createElement(Message_1.default, { code: "epic.code.redemption.posa.page.vbuckscard.validate.isWalletCode.redirectMessage" }))),
                        react_1.default.createElement("p", { className: "overlay-content-block__redirecting-now" },
                            react_1.default.createElement(VerifyingIcon_1.default, null),
                            react_1.default.createElement("span", null,
                                react_1.default.createElement(Message_1.default, { code: "epic.code.redemption.posa.page.vbuckscard.validate.isWalletCode.redirecting" })))),
                    react_1.default.createElement("div", { className: "overlay-content-block" },
                        react_1.default.createElement("img", { alt: "Gift Card", src: image })))))));
};
RedirectWalletOverlay.propTypes = {
    image: prop_types_1.default.string
};
exports.default = RedirectWalletOverlay;
//# sourceMappingURL=RedirectWalletOverlay.js.map